const menus = [
  {
    name: 'Home',
    sectionId: 'home'
  },
  {
    name: 'Engineer',
    sectionId: 'engineer'
  },
  {
    name: 'Developer',
    sectionId: 'developer'
  },
  {
    name: 'Straightliner',
    link: 'https://www.straightliner.c-chapellier.com'
  },
  {
    name: 'Facebook Friends Grapher',
    link: 'https://www.facebook-friends-grapher.c-chapellier.com/'
  }
]

export { menus }
